import { WSMutationConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_PAYEE } from "../../payee/keys";
import {
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
  QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE
} from "../keys";
import {
  IPayeeEngagementResponse,
  IPayeeEngagementUpdateRequest
} from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";
import { updatePayeeEngagementByPayeeId } from "../../../services/payeeEngagement";
import { QUERY_PAYEE_ROWS } from "../../search/payee/queries/useQueryPayeeRows";
import { QUERY_PAYEE_ROWS_SUMMARY } from "../../search/payee/queries/useQueryPayeeRowsSummary";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import {
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_FULL_LIST_SIZE,
  QUERY_REQUIREMENTS_LIST
} from "../../requirements/keys";

type IPayeeEngagementUpdateParams = IPayeeEngagementUpdateRequest & {
  payeeId: string;
  engagementId: string;
};

export const useMutationUpdatePayeeEngagement = (
  config?: WSMutationConfig<IPayeeEngagementResponse, WSServiceError>
) => {
  const xWingspanPayerId = useXWingspanPayerId();
  return useWSMutation(
    (request: IPayeeEngagementUpdateParams) => {
      const { engagementId, payeeId, ...rest } = request;
      return updatePayeeEngagementByPayeeId(
        payeeId,
        engagementId,
        rest,
        xWingspanPayerId
      );
    },
    {
      ...config,
      dependencies: [
        QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
        QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE,
        QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
        QUERY_PAYEE,
        QUERY_PAYEE_ROWS,
        QUERY_PAYEE_ROWS_SUMMARY,
        QUERY_REQUIREMENTS_FULL_LIST,
        QUERY_REQUIREMENTS_FULL_LIST_SIZE,
        QUERY_REQUIREMENTS_LIST
      ]
    }
  );
};
